<template>
    <div class="slider-component svg-container">
        <svg
            ref="svg"
            preserveAspectRatio="xMidYMid"
            width="482"
            height="119"
            viewBox="0 0 482 119"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <title>Slider Component</title>

            <g ref="slider">
                <g ref="sliderBackgrounds">
                    <!-- This is the curve section of the slider background -->
                    <g :id="'SliderBackgroundCurve' + questionName">
                        <path
                            v-if="currentBackground === 'Availability1'"
                            id="Availability1"
                            d="M21.2465 72.537L1 71.9936V99H481V97.1433C463.682 92.6773 445.711 91.3047 427.915 93.0885L370.626 98.8312H349.661C323.752 98.8312 298.001 94.8038 273.329 86.8932L265.291 84.3158C254.075 80.7195 243.138 76.3041 232.568 71.1054L218.061 63.9697C195.811 53.0254 171.416 47.1335 146.624 46.7155L133.637 46.4966C114.307 46.1706 95.1973 50.6489 78.0241 59.5295C60.5007 68.5913 40.9672 73.0663 21.2465 72.537Z"
                            fill="#F5F6FF"
                            stroke="#3751FF"
                        />
                        <path
                            v-if="currentBackground === 'Availability2'"
                            id="Availability2"
                            d="M1 99H481V91.4571H445.064L375.873 82.8518C355.189 80.2793 335.356 73.0553 317.863 61.722L314.998 59.8657C294.995 46.9063 271.732 39.8759 247.899 39.5883L235.87 39.4431C212.247 39.158 189.365 47.6796 171.683 63.3471C155.885 77.345 135.878 85.6868 114.815 87.0574L47.2032 91.4571H1V99Z"
                            fill="#F5F6FF"
                            stroke="#3751FF"
                        />
                        <path
                            v-if="currentBackground === 'Availability3'"
                            id="Availability3"
                            d="M481 99V97.1015V72.5939H437.364L358.205 66.4953C345.286 65.4999 332.309 65.5105 319.391 66.5269L242.283 72.5939L144.23 85.7107L45.1497 92.269H1V99H481Z"
                            fill="#F5F6FF"
                            stroke="#3751FF"
                        />
                        <path
                            v-if="currentBackground === 'Availability4'"
                            id="Availability4"
                            d="M481 99V85.9651H433.77L380.38 93.1686C353.826 93.1686 328.096 83.9511 307.583 67.0899L304.402 64.4752C285.175 48.6712 260.971 40.1885 236.085 40.5321C220.559 40.7464 205.273 44.3917 191.321 51.2068L167.758 62.7169C152.466 70.1871 136.366 75.8773 119.775 79.6756L71.1497 90.8082C52.8479 94.9983 34.1323 97.1134 15.357 97.1134H1V99H481Z"
                            fill="#F5F6FF"
                            stroke="#3751FF"
                        />
                        <path
                            v-if="currentBackground === 'Availability5'"
                            id="Availability5"
                            d="M481 87.8038V98.8278L157.58 98.9438L157.578 98.9438H157.573L1 99V98.8278L157.573 98.9438H157.578L157.58 98.9438L160.355 98.9358C182.589 98.8713 202.266 84.5319 209.138 63.3862L210.485 59.2406C213.758 49.1694 220.826 40.77 230.191 35.8252C240.789 30.2287 253.316 29.5875 264.431 34.0728L274.203 38.0165C281.272 40.8689 287.768 44.9725 293.38 50.1303L297.588 53.9974C312.358 67.5721 331.053 76.1133 350.984 78.3931L433.257 87.8038H481Z"
                            fill="#F5F6FF"
                            stroke="#3751FF"
                        />
                        <path
                            v-if="currentBackground === 'Integrity1'"
                            id="Integrity1"
                            d="M481 97.9635L162.174 98.652C159.174 98.7687 156.169 98.8272 153.163 98.8272H80.9994L1 99V98.8272H80.9994L162.174 98.652C183.809 97.8098 205.235 93.9383 225.823 87.1385C239.165 82.7319 252.88 79.5482 266.798 77.6266L345.984 66.6944L393.727 56.8472L481 47V97.6179V97.9635Z"
                            fill="#F5F6FF"
                            stroke="#3751FF"
                        />
                        <path
                            v-if="currentBackground === 'Integrity2'"
                            id="Integrity2"
                            d="M481 99V98.8276V81.5862L347.011 55.5517L324.262 51.9227C312.116 49.9851 299.749 49.8738 287.57 51.5923L270.036 54.0667C253.729 56.3678 238.685 64.1319 227.363 76.0902C213.62 90.6051 194.511 98.8276 174.522 98.8276H1V99H481Z"
                            fill="#F5F6FF"
                            stroke="#3751FF"
                        />
                        <path
                            v-if="currentBackground === 'Integrity3'"
                            id="Integrity3"
                            d="M481 99V98.8287V1H443.028C414.856 1 391.087 21.9636 387.567 49.9143C384.047 77.8651 360.277 98.8287 332.106 98.8287H251.524H144.23H45.1497H1V99H481Z"
                            fill="#F5F6FF"
                            stroke="#3751FF"
                        />
                        <path
                            v-if="currentBackground === 'Integrity4'"
                            id="Integrity4"
                            d="M481 99V96.2579V2H438.844C434.785 2 430.735 2.37239 426.745 3.11247C407.15 6.74662 390.226 18.9963 380.652 36.4752L356.343 80.8547C350.272 91.9378 338.641 98.8286 326.004 98.8286H241.257H1V99H481Z"
                            fill="#F5F6FF"
                            stroke="#3751FF"
                        />
                        <path
                            v-if="currentBackground === 'Integrity5'"
                            id="Integrity5"
                            d="M1 99L481 98.8288V17H470.534C435.064 17 400.948 30.6161 375.225 55.0384C353.259 75.8941 325.058 88.9691 294.947 92.2583L281.813 93.6931L148.85 98.6576L43.6096 98.8288H1V99Z"
                            fill="#F5F6FF"
                            stroke="#3751FF"
                        />

                        <path
                            v-if="currentBackground === 'Confidentiality1'"
                            id="Confidentiality1"
                            d="M48.1795 51L1 53.9103V98.8272L481 99V98.6545H296.355C260.472 98.6545 225.091 90.2183 193.069 74.0267C158.025 56.3072 119.011 47.9014 79.7796 49.6176L48.1795 51Z"
                            fill="#F5F6FF"
                            stroke="#3751FF"
                        />
                        <path
                            v-if="currentBackground === 'Confidentiality2'"
                            id="Confidentiality2"
                            d="M1 99H481V91.6007H435.31L340.337 78.5227H276.498C254.39 78.5227 232.642 72.9287 213.278 62.2614C193.914 51.5941 172.166 46 150.058 46H139.652C116.03 46 93.112 54.0412 74.6684 68.8003C56.2249 83.5595 33.3067 91.6007 9.68473 91.6007H1V99Z"
                            fill="#F5F6FF"
                            stroke="#3751FF"
                        />
                        <path
                            v-if="currentBackground === 'Confidentiality3'"
                            id="Confidentiality3"
                            d="M481 99V98.8319V74.9558H437.364L338.797 67.5575L241.77 61L167.999 65.9079C151.509 67.0049 135.169 69.7344 119.217 74.0562L77.2595 85.4241C55.9469 91.1985 33.9632 94.1239 11.8822 94.1239H1V98.8319L481 99Z"
                            fill="#F5F6FF"
                            stroke="#3751FF"
                        />
                        <path
                            v-if="currentBackground === 'Confidentiality4'"
                            id="Confidentiality4"
                            d="M481 98.7192V92.726H440.444L362.285 98L311.091 98.4506C291.301 98.6247 272.009 92.2532 256.215 80.3273C249.359 75.1496 241.794 70.9834 233.753 67.9561L222.944 63.8867C203.823 56.688 183.559 53 163.128 53H132.037C112.585 53 93.2734 56.3002 74.9251 62.7603C56.5768 69.2203 37.2656 72.5205 17.8133 72.5205H1V98.7192H481Z"
                            fill="#F5F6FF"
                            stroke="#3751FF"
                        />
                        <path
                            v-if="currentBackground === 'Confidentiality5'"
                            id="Confidentiality5"
                            d="M481 98.8249V81.8405H439.417H374.614C353.749 81.8405 333.159 77.0796 314.412 67.9202C295.664 58.7609 275.074 54 254.209 54H233.014C211.394 54 190.38 61.1402 173.235 74.3113C156.091 87.4824 135.077 94.6226 113.457 94.6226H46.6898H1V99L481 98.8249Z"
                            fill="#F5F6FF"
                            stroke="#3751FF"
                        />
                    </g>
                </g>
                <rect
                    ref="actualChartArea"
                    x="14"
                    y="25"
                    width="459"
                    height="90"
                />

                <!-- slider scale text -->
                <g>
                    <path
                        d="M14.1825 108.273H13.1257L10.9439 109.722V110.795L13.0746 109.381H13.1257V117H14.1825V108.273Z"
                        fill="#767676"
                    />
                    <rect x="70" y="108" width="1" height="10" fill="#C8C8C8" />
                    <path
                        d="M125.271 117H130.776V116.062H126.719V115.994L128.68 113.898C130.18 112.291 130.623 111.541 130.623 110.574C130.623 109.227 129.532 108.153 127.998 108.153C126.468 108.153 125.305 109.193 125.305 110.727H126.31C126.31 109.734 126.954 109.074 127.964 109.074C128.91 109.074 129.634 109.653 129.634 110.574C129.634 111.379 129.161 111.976 128.151 113.08L125.271 116.233V117Z"
                        fill="#767676"
                    />
                    <rect
                        x="185"
                        y="108"
                        width="1"
                        height="10"
                        fill="#C8C8C8"
                    />
                    <path
                        d="M243.032 117.119C244.724 117.119 245.981 116.058 245.981 114.631C245.981 113.523 245.325 112.717 244.225 112.534V112.466C245.107 112.197 245.657 111.473 245.657 110.489C245.657 109.253 244.681 108.153 243.066 108.153C241.558 108.153 240.305 109.082 240.254 110.455H241.276C241.315 109.585 242.141 109.074 243.049 109.074C244.012 109.074 244.634 109.658 244.634 110.54C244.634 111.46 243.914 112.057 242.879 112.057H242.18V112.994H242.879C244.204 112.994 244.941 113.668 244.941 114.631C244.941 115.555 244.136 116.182 243.015 116.182C242.005 116.182 241.204 115.662 241.14 114.818H240.066C240.13 116.19 241.34 117.119 243.032 117.119Z"
                        fill="#767676"
                    />
                    <rect
                        x="300"
                        y="108"
                        width="1"
                        height="10"
                        fill="#C8C8C8"
                    />
                    <path
                        d="M354.849 115.21H358.957V117H359.963V115.21H361.156V114.273H359.963V108.273H358.684L354.849 114.341V115.21ZM358.957 114.273H355.991V114.205L358.889 109.619H358.957V114.273Z"
                        fill="#767676"
                    />
                    <rect
                        x="415"
                        y="108"
                        width="1"
                        height="10"
                        fill="#C8C8C8"
                    />
                    <path
                        d="M472.98 117.119C474.642 117.119 475.861 115.892 475.861 114.222C475.861 112.53 474.685 111.29 473.083 111.29C472.494 111.29 471.923 111.499 471.566 111.784H471.514L471.821 109.21H475.469V108.273H470.935L470.406 112.568L471.395 112.688C471.757 112.428 472.375 112.24 472.912 112.244C474.024 112.253 474.838 113.097 474.838 114.239C474.838 115.359 474.054 116.182 472.98 116.182C472.085 116.182 471.374 115.607 471.293 114.818H470.27C470.334 116.148 471.48 117.119 472.98 117.119Z"
                        fill="#767676"
                    />
                    <line
                        x1="1"
                        y1="99.5"
                        x2="481"
                        y2="99.5"
                        stroke="#C8C8C8"
                    />
                </g>

                <!-- thumb -->

                <g
                    :id="'sliderHandleInit' + questionName"
                    ref="minHandle"
                    class="slider-handle"
                    :x="minHandlePos"
                    y="0"
                >
                    <rect
                        height="120"
                        width="10"
                        @mousedown="sliderMoveStart($event)"
                    />
                    <image
                        width="10"
                        height="105"
                        y="5"
                        xlink:href="@/assets/img/slider_handle.svg"
                        class="no-drag"
                    />
                </g>
            </g>
        </svg>
    </div>
</template>

<script>
import * as d3 from "d3";
import {mapGetters} from "vuex";

export default {
    name: "ImportanceSlider",
    components: {},
    props: ["position", "questionName", "tabName"],
    data: function() {
        return {
            currentMousePos: 0,
            minHandlePos: null,
            sliderMoving: false,
            dragAreaWidth: null,
            svgWidth: null,
            xScale: null,
            sliderBB: null,
            handleBB: null,
            sliderHandlePosition: 1,
            handle: null
        };
    },
    mounted() {
        this.sliderHandlePosition = this.position;
        // set min and max handles
        this.handle = document.getElementById(
            "sliderHandleInit" + this.questionName
        );

        // Set up SVG drawing options
        this.svgWidth = this.$refs.sliderBackgrounds.getBoundingClientRect().width;
        this.dragAreaWidth = this.$refs.actualChartArea.getBoundingClientRect().width;

        // Set up D3 scales
        this.xScale = d3.scaleLinear([0, this.dragAreaWidth], [1, 5]);

        // calculate the width of a handle.
        this.handleBB = this.$refs.minHandle.getBoundingClientRect();

        // calculate a minimum handle position
        this.minHandlePos =
            (this.svgWidth - this.dragAreaWidth) / 2 - this.handleBB.width / 3;

        // set initial handle positions
        this.handle.setAttribute(
            "transform",
            "translate(" + this.minHandlePos.toString() + 25 + ", 0)"
        );
    },
    computed: {
        ...mapGetters(["surveyTabs"]),
        currentBackground() {
            if (this.tabName === this.surveyTabs[1].name) {
                if (this.questionName == "availability") {
                    return "Availability5";
                } else if (this.questionName == "confidentiality") {
                    return "Confidentiality5";
                } else if (this.questionName == "integrity") {
                    return "Integrity5";
                } else return null;
            } else if (
                this.tabName === this.surveyTabs[2].name ||
                this.tabName === this.surveyTabs[3].name
            ) {
                if (this.questionName == "availability") {
                    return "Availability2";
                } else if (this.questionName == "confidentiality") {
                    return "Confidentiality2";
                } else if (this.questionName == "integrity") {
                    return "Integrity2";
                } else return null;
            } else if (
                this.tabName === this.surveyTabs[4].name ||
                this.tabName === this.surveyTabs[5].name ||
                this.tabName === this.surveyTabs[6].name
            ) {
                if (this.questionName == "availability") {
                    return "Availability3";
                } else if (this.questionName == "confidentiality") {
                    return "Confidentiality3";
                } else if (this.questionName == "integrity") {
                    return "Integrity3";
                } else return null;
            } else if (
                this.tabName === this.surveyTabs[7].name ||
                this.tabName == this.surveyTabs[8].name ||
                this.tabName === this.surveyTabs[9].name ||
                this.tabName === this.surveyTabs[10].name
            ) {
                if (this.questionName == "availability") {
                    return "Availability4";
                } else if (this.questionName == "confidentiality") {
                    return "Confidentiality4";
                } else if (this.questionName == "integrity") {
                    return "Integrity4";
                } else return null;
            } else if (this.tabName === this.surveyTabs[11].name) {
                if (this.questionName == "availability") {
                    return "Availability1";
                } else if (this.questionName == "confidentiality") {
                    return "Confidentiality1";
                } else if (this.questionName == "integrity") {
                    return "Integrity1";
                } else return null;
            } else return null;
        }
    },
    methods: {
        sliderMoveStart() {
            this.sliderMoving = true;

            this.sliderBB = this.$refs.sliderBackgrounds.getBoundingClientRect();

            window.addEventListener("mousemove", this.sliderMove);
            window.addEventListener("mouseup", this.sliderMoveEnd);
        },

        sliderMove(event) {
            event.preventDefault();

            if (this.sliderMoving) {
                let newPos = event.x - this.sliderBB.left;

                // This is supposed to clamp `newPos` within the range of the slider.
                const minPos =
                    (this.svgWidth - this.dragAreaWidth) / 2 -
                    this.handleBB.width / 2;
                const maxPos =
                    this.svgWidth -
                    (this.svgWidth - this.dragAreaWidth) / 2 -
                    this.handleBB.width / 2.5;
                // Clamping `newPos`
                newPos =
                    newPos < minPos
                        ? minPos
                        : newPos > maxPos
                        ? maxPos
                        : newPos;

                // Set position of handle and mask
                this.currentMousePos = newPos;

                this.handle = document.getElementById(
                    "sliderHandleInit" + this.questionName
                );

                // Handle
                this.handle.setAttribute(
                    "transform",
                    "translate(" + this.currentMousePos.toString() + ", 0)"
                );

                // set positions so that numbers can dynamically highlight.
                this.sliderHandlePosition = this.xScale(
                    this.handle.getBoundingClientRect().x +
                        this.handleBB.width / 2 -
                        this.$refs.actualChartArea.getBoundingClientRect().x
                );
            }
        },
        sliderMoveEnd() {
            this.handle = document.getElementById(
                "sliderHandleInit" + this.questionName
            );

            // Round the minHandle Position
            if (this.sliderHandlePosition < 1) {
                this.sliderHandlePosition = 1;
            } else if (this.sliderHandlePosition > 5) {
                this.sliderHandlePosition = 5;
            }

            // Reset moving variables
            this.sliderBB = null;
            this.currentMousePos = 0;

            // Delay setting slider moving to false until after transition
            setTimeout(() => {
                this.sliderMoving = false;
            }, 1000);

            //save the position
            this.$emit(
                "setValue",
                Math.round(this.sliderHandlePosition * 10) / 10
            );

            // remove event listeners
            window.removeEventListener("mousemove", this.sliderMove);
            window.removeEventListener("mouseup", this.sliderMoveEnd);
        },
        updateSliderPosition() {
            if (!this.sliderMoving) {
                d3.select(this.handle)
                    .transition()
                    .duration(1000)
                    .attr(
                        "transform",
                        "translate(" +
                            (this.xScale.invert(this.sliderHandlePosition) +
                                this.handleBB.width / 1.2) +
                            ")"
                    );
            }
        }
    },
    watch: {
        position: function(newVal, oldVal) {
            this.sliderHandlePosition = newVal;
            this.updateSliderPosition();
        },
        sliderHandlePosition: function() {
            this.updateSliderPosition();
        }
    }
};
</script>

<style lang="scss" scoped>
.slider-component {
    svg {
        display: block;
        margin: auto;
    }

    .slider-handle {
        fill: transparent;
        cursor: pointer;
    }

    .no-drag {
        user-select: none;
        pointer-events: none;
    }
}
</style>
